import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import {
  StatieItems,
} from "../../components";

function NewStatiegeldStatsScreen() {
  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Statiegeld Stats
        </h1>
        <div className="flex" />
      </div>
      <StatieItems />
    </div>
  );
}

export default withProtectedRoute(NewStatiegeldStatsScreen);
